import React from "react";

const ShoppingItem = ({ image, title, maker, price, link }) => {
  return (
    <div
      className="w-[calc(100%-46px)] max-w-[600px] flex items-center justify-between h-[160px] mx-auto cursor-pointer mb-[30px] md:mb-[50px]"
      onClick={() => {
        window.location.href = link;
      }}
    >
      <div className="w-[130px] md:w-[160px] h-[160px] md:h-[190px]">
        <img src={image} alt={`${title} 이미지`} className="w-[130px] md:w-[160px] h-[160px] md:h-[190px] rounded-[10px]" />
      </div>
      <div className="flex-1 flex flex-col justify-between items-start h-[160px] md:h-[170px] break-keep pl-[10px] md:pl-[20px] text-left">
        <div>
          <div className="text-xs md:text-base block text-[#b6b7b9]">{maker}</div>
          <div className="text-base md:text-xl block">{title}</div>
        </div>
        <div className="text-xl md:text-2xl font-semibold block mb-[5px]">{price}</div>
      </div>
    </div>
  );
};

export default ShoppingItem;
